// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.apps {
  background: #fff;
}

.apps__head {
  margin-bottom: 40px;
}

.apps__list {
  display: flex;
  flex-direction: column;
  gap: 34px;
}

.app-panel {
  display: grid;
  grid-template-columns: 0.5fr 1.5fr;
  gap: 48px;
  align-items: start;
  border-radius: var(--radius-xl);
  padding: 48px;
  border: 1px solid var(--border-soft);
}

.app-panel--reverse {
  direction: rtl;
}

.app-panel--reverse > * {
  direction: ltr;
}

.app-panel--teal {
  background: linear-gradient(160deg, var(--teal-tint) 0%, #fff 55%);
}

.app-panel--amber {
  background: linear-gradient(160deg, var(--amber-tint) 0%, #fff 55%);
}

.app-panel--business {
  background: linear-gradient(160deg, var(--teal-tint) 0%, #fff 40%, var(--amber-tint) 100%);
}

.app-panel__media {
  display: flex;
  justify-content: center;
  position: sticky;
  top: 110px;
}

.app-panel__ring {
  width: 100%;
  max-width: 240px;
  aspect-ratio: 1 / 1;
  border-radius: 50%;
  padding: 8px;
}

.app-panel--teal .app-panel__ring {
  background: linear-gradient(135deg, var(--teal), var(--teal-dark));
}

.app-panel--amber .app-panel__ring {
  background: linear-gradient(135deg, var(--amber), var(--amber-dark));
}

.app-panel__ring--dual {
  background: linear-gradient(135deg, var(--teal), var(--amber));
}

.app-panel__ring img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  border: 6px solid #fff;
}

.pill--teal {
  color: var(--teal-dark);
  background: rgba(0, 198, 167, 0.14);
}

.pill--amber {
  color: var(--amber-dark);
  background: rgba(245, 158, 11, 0.16);
}

.pill--emerald {
  color: var(--emerald-dark);
  background: rgba(5, 150, 105, 0.14);
}

.pill--dual {
  color: #fff;
  background: linear-gradient(120deg, var(--teal-dark), var(--amber-dark));
}

.app-panel__copy h3 {
  margin-top: 14px;
  font-size: 26px;
  font-weight: 800;
}

.app-panel__blurb {
  margin-top: 12px;
  max-width: 680px;
  font-size: 15px;
}

/* ── Customer app: category cards ────────────────────────────────────────── */

.app-panel__categories {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 14px;
  margin: 30px 0 8px;
}

.category-card {
  display: flex;
  gap: 12px;
  background: rgba(255, 255, 255, 0.7);
  border: 1px solid var(--border-soft);
  border-radius: var(--radius-md);
  padding: 16px;
}

.category-card__icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 11px;
  background: #fff;
  color: var(--teal-dark);
  box-shadow: var(--shadow-sm);
}

.category-card__title-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.category-card h4 {
  font-size: 14.5px;
  font-weight: 700;
}

.category-card p {
  margin-top: 4px;
  font-size: 12.5px;
  line-height: 1.5;
}

/* ── Customer app: chip groups ───────────────────────────────────────────── */

.app-panel__chipgroups {
  margin-top: 26px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.chipgroup h5 {
  font-family: var(--font-display);
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--text-dark);
  margin-bottom: 10px;
}

.chipgroup__row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.chip {
  font-size: 12.5px;
  font-weight: 600;
  color: var(--text-grey);
  background: #fff;
  border: 1px solid var(--border-soft);
  padding: 6px 13px;
  border-radius: 100px;
}

.app-panel__reqheading {
  margin-top: 30px;
  font-family: var(--font-display);
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.app-panel__requirements {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 14px 0 28px;
}

.app-panel__requirements li {
  position: relative;
  padding-left: 22px;
  font-size: 13.8px;
  color: var(--text-grey);
  line-height: 1.55;
}

.app-panel__requirements li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 7px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--text-mute);
}

/* ── Business app: rider / merchant / vendor personas ───────────────────── */

.personas {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin: 30px 0 32px;
}

.persona {
  border-radius: var(--radius-md);
  padding: 22px;
  /* This panel's own background is a pale tint, not a photo or a dark
     gradient, so a low-opacity fill alone barely shows up against it —
     higher opacity plus a real shadow keep the card clearly readable. */
  background: rgba(255, 255, 255, 0.88);
  border: 1px solid var(--border-soft);
  box-shadow: var(--shadow-sm);
}

.persona__subtitle {
  margin-top: 10px;
  font-size: 12.5px;
  color: var(--text-grey);
}

.persona h5 {
  margin-top: 18px;
  font-family: var(--font-display);
  font-size: 11.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--text-dark);
  margin-bottom: 10px;
}

.persona ul {
  display: flex;
  flex-direction: column;
  gap: 9px;
}

.persona li {
  position: relative;
  padding-left: 20px;
  font-size: 13px;
  color: var(--text-grey);
  line-height: 1.5;
}

.persona li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 6px;
  width: 7px;
  height: 7px;
  border-radius: 3px;
}

.persona--teal li::before {
  background: var(--teal);
}

.persona--amber li::before {
  background: var(--amber);
}

.persona--emerald li::before {
  background: var(--emerald);
}

.persona__requirements li::before {
  border-radius: 50%;
  background: var(--text-mute) !important;
}

/* Three persona columns need more room than two did — drop to two before
   the full single-column stack below kicks in, so text never gets cramped
   into an unreadably narrow third column on a mid-width viewport. */
@media (max-width: 1280px) {
  .personas {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 980px) {
  .app-panel {
    grid-template-columns: 1fr;
    padding: 34px 26px;
    direction: ltr !important;
  }
  .app-panel__media {
    position: static;
  }
  .app-panel__ring {
    max-width: 180px;
  }
  .app-panel__categories {
    grid-template-columns: 1fr;
  }
  .personas {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Apps.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,0FAA0F;AAC5F;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,wEAAwE;AAC1E;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,oCAAoC;EACpC,oCAAoC;EACpC,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,+EAA+E;;AAE/E;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,oCAAoC;EACpC,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,8EAA8E;;AAE9E;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,aAAa;EACb;;wEAEsE;EACtE,qCAAqC;EACrC,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;;oEAEoE;AACpE;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,kBAAkB;IAClB,yBAAyB;EAC3B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".apps {\n  background: #fff;\n}\n\n.apps__head {\n  margin-bottom: 40px;\n}\n\n.apps__list {\n  display: flex;\n  flex-direction: column;\n  gap: 34px;\n}\n\n.app-panel {\n  display: grid;\n  grid-template-columns: 0.5fr 1.5fr;\n  gap: 48px;\n  align-items: start;\n  border-radius: var(--radius-xl);\n  padding: 48px;\n  border: 1px solid var(--border-soft);\n}\n\n.app-panel--reverse {\n  direction: rtl;\n}\n\n.app-panel--reverse > * {\n  direction: ltr;\n}\n\n.app-panel--teal {\n  background: linear-gradient(160deg, var(--teal-tint) 0%, #fff 55%);\n}\n\n.app-panel--amber {\n  background: linear-gradient(160deg, var(--amber-tint) 0%, #fff 55%);\n}\n\n.app-panel--business {\n  background: linear-gradient(160deg, var(--teal-tint) 0%, #fff 40%, var(--amber-tint) 100%);\n}\n\n.app-panel__media {\n  display: flex;\n  justify-content: center;\n  position: sticky;\n  top: 110px;\n}\n\n.app-panel__ring {\n  width: 100%;\n  max-width: 240px;\n  aspect-ratio: 1 / 1;\n  border-radius: 50%;\n  padding: 8px;\n}\n\n.app-panel--teal .app-panel__ring {\n  background: linear-gradient(135deg, var(--teal), var(--teal-dark));\n}\n\n.app-panel--amber .app-panel__ring {\n  background: linear-gradient(135deg, var(--amber), var(--amber-dark));\n}\n\n.app-panel__ring--dual {\n  background: linear-gradient(135deg, var(--teal), var(--amber));\n}\n\n.app-panel__ring img {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 6px solid #fff;\n}\n\n.pill--teal {\n  color: var(--teal-dark);\n  background: rgba(0, 198, 167, 0.14);\n}\n\n.pill--amber {\n  color: var(--amber-dark);\n  background: rgba(245, 158, 11, 0.16);\n}\n\n.pill--emerald {\n  color: var(--emerald-dark);\n  background: rgba(5, 150, 105, 0.14);\n}\n\n.pill--dual {\n  color: #fff;\n  background: linear-gradient(120deg, var(--teal-dark), var(--amber-dark));\n}\n\n.app-panel__copy h3 {\n  margin-top: 14px;\n  font-size: 26px;\n  font-weight: 800;\n}\n\n.app-panel__blurb {\n  margin-top: 12px;\n  max-width: 680px;\n  font-size: 15px;\n}\n\n/* ── Customer app: category cards ────────────────────────────────────────── */\n\n.app-panel__categories {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 14px;\n  margin: 30px 0 8px;\n}\n\n.category-card {\n  display: flex;\n  gap: 12px;\n  background: rgba(255, 255, 255, 0.7);\n  border: 1px solid var(--border-soft);\n  border-radius: var(--radius-md);\n  padding: 16px;\n}\n\n.category-card__icon {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 38px;\n  height: 38px;\n  border-radius: 11px;\n  background: #fff;\n  color: var(--teal-dark);\n  box-shadow: var(--shadow-sm);\n}\n\n.category-card__title-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.category-card h4 {\n  font-size: 14.5px;\n  font-weight: 700;\n}\n\n.category-card p {\n  margin-top: 4px;\n  font-size: 12.5px;\n  line-height: 1.5;\n}\n\n/* ── Customer app: chip groups ───────────────────────────────────────────── */\n\n.app-panel__chipgroups {\n  margin-top: 26px;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.chipgroup h5 {\n  font-family: var(--font-display);\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: var(--text-dark);\n  margin-bottom: 10px;\n}\n\n.chipgroup__row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.chip {\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--text-grey);\n  background: #fff;\n  border: 1px solid var(--border-soft);\n  padding: 6px 13px;\n  border-radius: 100px;\n}\n\n.app-panel__reqheading {\n  margin-top: 30px;\n  font-family: var(--font-display);\n  font-size: 13px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.app-panel__requirements {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin: 14px 0 28px;\n}\n\n.app-panel__requirements li {\n  position: relative;\n  padding-left: 22px;\n  font-size: 13.8px;\n  color: var(--text-grey);\n  line-height: 1.55;\n}\n\n.app-panel__requirements li::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 7px;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--text-mute);\n}\n\n/* ── Business app: rider / merchant / vendor personas ───────────────────── */\n\n.personas {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 24px;\n  margin: 30px 0 32px;\n}\n\n.persona {\n  border-radius: var(--radius-md);\n  padding: 22px;\n  /* This panel's own background is a pale tint, not a photo or a dark\n     gradient, so a low-opacity fill alone barely shows up against it —\n     higher opacity plus a real shadow keep the card clearly readable. */\n  background: rgba(255, 255, 255, 0.88);\n  border: 1px solid var(--border-soft);\n  box-shadow: var(--shadow-sm);\n}\n\n.persona__subtitle {\n  margin-top: 10px;\n  font-size: 12.5px;\n  color: var(--text-grey);\n}\n\n.persona h5 {\n  margin-top: 18px;\n  font-family: var(--font-display);\n  font-size: 11.5px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: var(--text-dark);\n  margin-bottom: 10px;\n}\n\n.persona ul {\n  display: flex;\n  flex-direction: column;\n  gap: 9px;\n}\n\n.persona li {\n  position: relative;\n  padding-left: 20px;\n  font-size: 13px;\n  color: var(--text-grey);\n  line-height: 1.5;\n}\n\n.persona li::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 6px;\n  width: 7px;\n  height: 7px;\n  border-radius: 3px;\n}\n\n.persona--teal li::before {\n  background: var(--teal);\n}\n\n.persona--amber li::before {\n  background: var(--amber);\n}\n\n.persona--emerald li::before {\n  background: var(--emerald);\n}\n\n.persona__requirements li::before {\n  border-radius: 50%;\n  background: var(--text-mute) !important;\n}\n\n/* Three persona columns need more room than two did — drop to two before\n   the full single-column stack below kicks in, so text never gets cramped\n   into an unreadably narrow third column on a mid-width viewport. */\n@media (max-width: 1280px) {\n  .personas {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n@media (max-width: 980px) {\n  .app-panel {\n    grid-template-columns: 1fr;\n    padding: 34px 26px;\n    direction: ltr !important;\n  }\n  .app-panel__media {\n    position: static;\n  }\n  .app-panel__ring {\n    max-width: 180px;\n  }\n  .app-panel__categories {\n    grid-template-columns: 1fr;\n  }\n  .personas {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
